import auth from './en-US/auth.json';
import emailValidationPage from './en-US/emailValidationPage.json';
import links from './en-US/links.json';
import remoteActivation from './en-US/remoteActivation.json';
import site from './en-US/site.json';
import tags from './en-US/tags.json';

export default { auth, emailValidationPage, links, remoteActivation, site, tags };
